<a [href]="url" [ngStyle]="{'color': overrideColor ? overrideColor : 'inherit'}" target="_blank">ⓘ</a>